export {
  default as TextAreaInput,
  type TextAreaInputProps,
} from './TextAreaInput';
